import { ERequestStatus } from '../../types/requestStatus';
import { TArticleListState } from '../../types/articleList';
import { EOrdering } from '../../repositories/journal/entities/journal/JournalMetaV2Schema';
import { EGetArticleListActionType, EResetArticleListActionType, TArticleListActions } from '../../actions/articleList';

export const defaultState: TArticleListState = {
  status: ERequestStatus.Initial,
  meta: {
    b2b: false,
    limit: 18,
    offset: 0,
    regionId: 0,
    rubricId: 0,
    tag: null,
    total: 0,
    ordering: EOrdering.Date_publish,
  },
  items: [],
};

export const articleListReducer = (state = defaultState, action: TArticleListActions) => {
  switch (action.type) {
    case EGetArticleListActionType.Loading:
      return { ...state, status: ERequestStatus.Loading };

    case EGetArticleListActionType.Succeed:
      return { ...state, ...action.payload, status: ERequestStatus.Succeed };

    case EGetArticleListActionType.AppendSucceed:
      return {
        ...state,
        meta: action.payload.meta,
        items: [...state.items, ...action.payload.items],
        status: ERequestStatus.Succeed,
      };

    case EGetArticleListActionType.Failed:
      return { ...state, status: ERequestStatus.Failed };

    case EResetArticleListActionType.Reset:
      return defaultState;

    default:
      return state;
  }
};
